module.exports = __webpack_public_path__ + "static/media/back2-min.bc8d3714.jpg";